import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { builderFieldRows, hiddenFields } from './builderFieldRows';
import { fieldEdits } from './fieldEdits';
import { FieldRow } from './FieldRow';
import type { IFieldsCardProps } from './IFieldsCardProps';
import { NewFieldRow } from './NewFieldRow';
import { addCustomField } from './patchFields';

const COLS = ['label', 'key', 'type', 'width', 'options', 'required', 'inList'] as const;

/**
 * Картка «Поля» конструктора (прототип v4): «Автоширина відповідає глобальним налаштуванням» і «Розміщення полів →», таблиця полів типу
 * запису, рядок додавання власного поля; спроєктовані поля, приховані в цьому просторі, — під таблицею з «Показати».
 */
export function FieldsCard({ rt, published, editor, strings, layoutTo }: IFieldsCardProps) {
  const { t } = useTranslation();
  const rows = builderFieldRows(rt, published, editor.patch);
  const hidden = hiddenFields(published, editor.patch);
  const taken = [...rt.fields.map((f) => f.key), ...(published?.fields ?? []).map((f) => f.key), ...(editor.patch.customFields ?? []).map((f) => f.key)];
  return (
    <section className="rb-card rb-card--flush" aria-label={t('rtBuilder.fields')}>
      <div className="rb-card__head">
        <span className="rb-card__title">{t('rtBuilder.fields')}</span>
        <span className="rb-card__aside">{t('rtBuilder.autoWidth')}<Link className="rb-btn rb-btn--link" to={layoutTo}>{t('rtBuilder.fieldLayout')}</Link></span>
      </div>
      <div className="rb-fields">
        <div className="rb-fields__inner">
          <div className="rb-frow rb-frow--head">
            {COLS.map((c) => <div key={c} title={c === 'width' ? t('rtBuilder.widthTip') : undefined}>{t(`rtBuilder.cols.${c}`)}</div>)}
            <div />
          </div>
          {rows.map((row) => <FieldRow key={row.field.key} rt={rt} row={row} strings={strings} canEdit={editor.canEdit} onEdit={editor.apply} />)}
          {!!hidden.length && (
            <div className="rb-hidden">
              <span className="rb-hidden__title">{t('rtBuilder.hidden')}</span>
              {hidden.map((f) => (
                <span key={f.key} className="rb-hidden__item">
                  {strings.field(rt.key, f.key, f.label)}
                  {editor.canEdit && <button type="button" className="rb-btn rb-btn--sm" onClick={() => editor.apply(fieldEdits.show(f.key))}>{t('rtBuilder.showField')}</button>}
                </span>
              ))}
            </div>
          )}
          <NewFieldRow taken={taken} lang={strings.lang} canEdit={editor.canEdit} onAdd={(f) => editor.apply((p) => addCustomField(p, f))} />
        </div>
      </div>
    </section>
  );
}
